import { useState } from "react";
import "../Stylesheets/AssessmentQuiz.css"; 

const AssessmentQuiz = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [responses, setResponses] = useState({
    background: "",
    experience: "",
    skillLevel: "",
    preferredLearning: "",
    goals: [],
    availability: "",
    previousEducation: "",
    computerAccess: "",
  });

  const questions = [
    {
      id: "background",
      title: "What is your current background?",
      type: "single",
      options: [
        {
          value: "student",
          label: "Current Student",
          description: "Currently pursuing education",
        },
        {
          value: "fresher",
          label: "Recent Graduate/Fresher",
          description: "Recently completed education",
        },
        {
          value: "career-gap",
          label: "Career Gap Individual",
          description: "Taking a break or changing careers",
        },
       
      ],
    },
   {
      id: "skillLevel",
      title: "How would you rate your current technical skill level?",
      type: "single",
      options: [
        {
          value: "beginner",
          label: "Beginner",
          description: "New to technology and programming",
        },
        {
          value: "intermediate",
          label: "Intermediate",
          description: "Some technical knowledge and experience",
        },
        {
          value: "some knowledge",
          label: "Some Knowledge",
          description: "Some technical Knowledge",
        },
      ],
    },
    {
      id: "goals",
      title: "What are your career goals? (Select all that apply)",
      type: "multiple",
      options: [
        {
          value: "frontend",
          label: "Frontend Developer",
          description: "Focus on user interfaces",
        },
        {
          value: "backend",
          label: "Backend Developer",
          description: "Focus on server-side development",
        },
        {
          value: "fullstack",
          label: "Full-Stack Developer",
          description: "Both frontend and backend",
        },
        {
          value: "mobile",
          label: "Mobile App Developer",
          description: "iOS/Android development",
        },
        {
          value: "devops",
          label: "DevOps Engineer",
          description: "Deployment and infrastructure",
        },
        
      ],
    },
  ];

  const currentQuestion = questions[currentStep - 1];
  const isLastStep = currentStep === questions.length;

  const handleResponse = (questionId, value) => {
    if (questions.find((q) => q.id === questionId)?.type === "multiple") {
      const currentValues = responses[questionId] || [];
      const newValues = currentValues.includes(value)
        ? currentValues.filter((v) => v !== value)
        : [...currentValues, value];
      setResponses((prev) => ({ ...prev, [questionId]: newValues }));
    } else {
      setResponses((prev) => ({ ...prev, [questionId]: value }));
    }
  };

  const handleNext = () => {
    if (currentStep < questions.length) setCurrentStep(currentStep + 1);
  };

  const handlePrevious = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSubmit = () => {
    console.log("Submitted:", responses);
    alert(
      "Assessment completed! We’ll contact you with personalized recommendations."
    );
  };

  const handleRetake = () => {
    setResponses({
      background: "",
      experience: "",
      skillLevel: "",
      preferredLearning: "",
      goals: [],
      availability: "",
      previousEducation: "",
      computerAccess: "",
    });
    setCurrentStep(1);
  };

  const canProceed =
    responses[currentQuestion.id] &&
    (currentQuestion.type === "single"
      ? responses[currentQuestion.id]
      : responses[currentQuestion.id].length > 0);

  return (
    <section className="quiz-section d-flex align-items-center justify-content-center ">
      <div className="container">
        {/* Header */}
        <div className="text-center">
          <h2
            className="fw-bold display-5 gradient-text"
            style={{ fontFamily: "'Merriweather', serif" }}
          >
            Personalized Assessment
          </h2>
          <p className=" fs-5 text-light my-3">
            Help us understand your background and goals so we can create the
            perfect learning path for you.
          </p>
        </div>
        <div className="row">

           {/* <div className="col-lg-6">
            <img src = "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img53468_IMG.png"/>
          </div> */}

          {/* Progress Bar */}
          <div className="col-lg-12">
          <div className="mb-4 ">
            <div className="d-flex justify-content-between text-light mb-2">
              <small>
                Level {currentStep} of {questions.length}
              </small>
              <small>
                {Math.round((currentStep / questions.length) * 100)}% Complete
              </small>
            </div>
            <div className="progress" style={{ height: "8px" }}>
              <div
                className="progress-bar progress-bar-striped bg-info"
                style={{ width: `${(currentStep / questions.length) * 100}%` }}
              ></div>
            </div>
          </div>

          {/* Question Card */}
          <div className="card quiz-card  p-4 mb-4">
            <h4 className="fw-bold text-center text-light mb-4">
              {currentQuestion.title}
            </h4>

            <div className="list-group ">
              {currentQuestion.options.map((option, index) => {
                const isSelected =
                  currentQuestion.type === "multiple"
                    ? (responses[currentQuestion.id] || []).includes(
                        option.value
                      )
                    : responses[currentQuestion.id] === option.value;

                return (
                  <button
                    key={index}
                    className={`list-group-item list-group-item-action p-3 mb-2 rounded ${
                      isSelected ? "active-option" : ""
                    }`}
                    onClick={() =>
                      handleResponse(currentQuestion.id, option.value)
                    }
                  >
                    <div className="d-flex align-items-start">
                      <div
                        className={`option-circle me-3 ${
                          isSelected ? "selected" : ""
                        }`}
                      >
                        {isSelected && "✔"}
                      </div>
                      <div>
                        <strong>{option.label}</strong>
                        <p className="mb-0 small text-dark">
                          {option.description}
                        </p>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>

            {/* Navigation */}
            <div className="d-flex justify-content-between mt-4">
              <button
                className="btn btn-outline-light"
                disabled={currentStep === 1}
                onClick={handlePrevious}
              >
                Previous
              </button>

              {isLastStep ? (
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-success"
                    disabled={!canProceed}
                    onClick={handleSubmit}
                  >
                    Complete Assessment
                  </button>
                  <button className="btn btn-info" onClick={handleRetake}>
                    Retake
                  </button>
                </div>
              ) : (
                <button
                  className="btn btn-primary"
                  disabled={!canProceed}
                  onClick={handleNext}
                >
                  Next
                </button>
              )}
            </div>
          </div>

          {/* Help Text */}
          <div className="text-center text-light mt-3">
            Need help?{" "}
            <a href="/contact" className="text-info text-decoration-underline">
              Contact our onboarding team
            </a>
          </div>
          </div>
         
        </div>
      </div>
    </section>
  );
};

export default AssessmentQuiz;
